import React from "react";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { logout } from "~/store/auth/actions";
import { setTheme } from "~/store/theme/actions";
import { useGlobalStore } from "~/store";

// Components
import useAlert from "~/common/hooks/useAlert";
import TransLanguageSelect from "~/common/components/TransLanguageSelect";

// Assets
import darkLogo from "~/assets/img/logo.svg";
import lightLogo from "~/assets/img/logo-black.svg";
import lightProfileImg from "~/assets/img/defaultImg/light-profile-large.png";
import darkNewImg from "~/common/components/Images";
import {
	AnnounceIcon,
	DarkThemeSwitchIcon,
	HeaderAlarmBellIcon,
	HeaderPluginIcon,
	LightThemeSwitchIcon,
} from "~/assets/svg/HeaderIcon";
import { ProfileIcon } from "~/assets/svg/InterfaceIcon";
import useRepository from "~/common/hooks/useRepository";
import { ALARM_LIST } from "~/store/alarm/repository";

const TopNav = () => {
	const { t } = useTranslation();
	const userDropDownRef = useRef(null);
	const [
		{
			user: { info },
			theme: { theme },
			alarm: { alarmList },
		},
		dispatch,
	] = useGlobalStore();
	const [userConfig, setUserConfig] = useState(localStorage.getItem("theme"));

	const navigate = useNavigate();
	const [toggleUserDropdown, setToggleUserDropdown] = useState(false);
	const [vcInfoAlert, ShowVcInfoAlert] = useAlert();
	const [getAlarmList] = useRepository(ALARM_LIST);
	const unreadAlarmCount = alarmList.filter((alarm) => !alarm.read).length;

	const switchMode = async () => {
		if (userConfig === "dark") {
			dispatch(setTheme("light"));
			localStorage.setItem("theme", "light");
		} else {
			dispatch(setTheme("dark"));
			localStorage.setItem("theme", "dark");
		}
		const htmlHd = document.getElementById("hd");
		if (userConfig === "dark") {
			htmlHd.classList.replace("dark", "light");
			setUserConfig("light");
		} else {
			htmlHd.classList.replace("light", "dark");
			setUserConfig("dark");
		}
	};

	function handleUserClickOutSide(e) {
		if (userDropDownRef.current && !userDropDownRef.current.contains(e.target)) {
			setToggleUserDropdown(false);
		}
	}

	useEffect(() => {
		if (toggleUserDropdown) {
			document.addEventListener("click", handleUserClickOutSide, false);
			return () => {
				document.addEventListener("click", handleUserClickOutSide, true);
			};
		}
	});

	const handleLogout = () => {
		dispatch(logout());
		navigate("/");
	};

	useEffect(() => {
		const curntType = localStorage.getItem("theme");
		const htmlHd = document.getElementById("hd");

		if (curntType !== null) {
			setUserConfig(curntType);
			if (curntType === "dark") {
				dispatch(setTheme("dark"));
				htmlHd.classList.replace("light", "dark");
			} else {
				dispatch(setTheme("light"));
				htmlHd.classList.replace("dark", "light");
			}
		} else {
			dispatch(setTheme("dark"));
			localStorage.setItem("theme", "dark");
			htmlHd.classList.replace("light", "dark");
			setUserConfig("dark");
		}
	}, []);

	useEffect(() => {
		getAlarmList();
	}, []);

	return (
		<nav className="l__nav">
			<div className="nav-left">
				<button className="btn-menuResize" />
				<button className="btn__neumorphic" color="primary" onClick={() => vcInfoAlert()}>
					<AnnounceIcon />
					{t("common.components.TopNav.info")}
				</button>
			</div>
			<div className="logo-wrap">
				<h1 className="logo" onClick={() => navigate("/dashboard")}>
					<img
						src={theme === "dark" ? darkLogo : lightLogo}
						alt={t("common.components.TopNav.lightLogo")}
					/>
				</h1>
			</div>
			<div className="nav-right">
				<div className="switch-wrap">
					<span className="switch-icon light">
						<LightThemeSwitchIcon />
					</span>
					<label className="switch">
						<input
							type="checkbox"
							checked={theme === "dark"}
							onChange={() => switchMode()}
						/>
						<span className="slider round" />
					</label>
					<span className="switch-icon dark">
						<DarkThemeSwitchIcon />
					</span>
				</div>
				{/* <ul className={`neumorphic-list ${info.role === "admin" ? "add-admin" : ""}`}> */}
				<ul className={`neumorphic-list add-admin`}>
					<li className="neumorphic-item" onClick={() => navigate("/alarm/list")}>
						<HeaderAlarmBellIcon />
						{unreadAlarmCount ? (
							<span className="badge">{unreadAlarmCount}</span>
						) : (
							<></>
						)}
					</li>
					{/*{info.role === "admin" && (*/}
					{/*	<li*/}
					{/*		className="neumorphic-item"*/}
					{/*		onClick={() => navigate("/myPage/plugin/list")}*/}
					{/*	>*/}
					{/*		<HeaderPluginIcon />*/}
					{/*	</li>*/}
					{/*)}*/}
					{/*<li className="neumorphic-item">*/}
					{/*	<TransLanguageSelect />*/}
					{/*</li>*/}
				</ul>
				<div className="user-wrap" ref={userDropDownRef}>
					<div
						className="user"
						onClick={() => setToggleUserDropdown(!toggleUserDropdown)}
					>
						<div className="img-wrap">
							{info.img ? (
								<img
									src={
										info.img
											? info.img
											: theme === "dark"
											? darkNewImg
											: lightProfileImg
									}
									onError={(e) => {
										e.target.src = darkNewImg;
									}}
									alt={`${
										info.img
											? info.name + t("common.components.TopNav.profile")
											: theme === "dark"
											? t("common.components.TopNav.darkProfile")
											: t("common.components.TopNav.lightProfile")
									}`}
								/>
							) : (
								<ProfileIcon />
							)}
						</div>
					</div>
					{toggleUserDropdown && (
						<ul className="user-dropdown-menu">
							{/*<li onClick={() => navigate("/mypage/account/profile")}>*/}
							{/*	{t("common.components.TopNav.account")}*/}
							{/*</li>*/}
							{/*<li onClick={() => navigate("/alarm/list")}>*/}
							{/*	{t("common.components.TopNav.alarm")}*/}
							{/*</li>*/}
							{/*<li onClick={() => navigate("/mypage/plugin/list")}>*/}
							{/*	{t("common.components.TopNav.plugin")}*/}
							{/*</li>*/}
							{/*{info.role === "admin" && (*/}
							{/*	<li onClick={() => navigate("/mypage/admin/team")}>*/}
							{/*		{t("common.components.TopNav.admin")}*/}
							{/*	</li>*/}
							{/*)}*/}
							<li onClick={handleLogout}>{t("common.components.TopNav.logout")}</li>
						</ul>
					)}
				</div>
			</div>
			<ShowVcInfoAlert
				message={t("common.components.TopNav.message")}
				type="info"
				confirm={t("common.components.TopNav.confirm")}
			/>
		</nav>
	);
};

export default TopNav;
